var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import * as React from "react";
import { Col, Row } from "react-bootstrap";
var SalesWarningPopup = function (props) {
    var ref = React.useRef(null);
    React.useEffect(function () {
        var body = document.querySelector("body");
        body.style.overflow = props.show ? "hidden" : "auto";
    }, [props.show]);
    React.useEffect(function () {
        function handleClickOutside(event) {
            if (ref.current &&
                !ref.current.contains(event.target) &&
                event.view.innerWidth - 17 >= event.clientX &&
                props.show) {
                (props === null || props === void 0 ? void 0 : props.closeOnOutsideClick) && props.setShow(false);
                (props === null || props === void 0 ? void 0 : props.handleOutsideClick) && props.handleOutsideClick();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, props.show]);
    return (React.createElement("div", { className: "saleswarning-pop" },
        React.createElement("div", { className: "modal-backdrop ".concat(props.show ? "show" : "fade") }),
        React.createElement("div", { className: "modal ".concat(props.modalTitle, " ").concat(props.show ? "show" : "fade") },
            React.createElement("div", { className: "modal-dialog ".concat(props.size) },
                React.createElement("div", { className: "modal-content", ref: ref },
                    React.createElement("div", { className: "modal-header align-items-center DMSan_16_700 justify-content-between" },
                        React.createElement("div", { className: "d-flex justify-conent-between align-items-center" },
                            props.icon && React.createElement("i", { className: props.icon }),
                            props.title && (React.createElement("h5", { className: "modal-title" }, props.hasOwnProperty("title") ? props.title : ""))),
                        React.createElement("button", { type: "button", className: "handCursor ".concat(props.showCloseIcon ? props.closeicon : ""), onClick: function () {
                                props.setShow(false);
                                setTimeout(function () {
                                    (props === null || props === void 0 ? void 0 : props.closeDropdown) && props.closeDropdown(false);
                                }, 0);
                            } },
                            React.createElement("i", { className: "" }))),
                    React.createElement("div", { className: "modal-body" }, props.children),
                    props.showFooter && (React.createElement("div", { className: "modal-footer" },
                        React.createElement(Row, null,
                            React.createElement(Col, { lg: 12 },
                                (props === null || props === void 0 ? void 0 : props.hideLeftButton) ? (React.createElement(React.Fragment, null)) : (React.createElement(EdButton, __assign({ className: "" }, props.btnvalueleft))),
                                (props === null || props === void 0 ? void 0 : props.hideRightButton) ? (React.createElement(React.Fragment, null)) : (React.createElement(EdButton, __assign({ className: "ms-4" }, props.btnvalueright))))))))))));
};
export default SalesWarningPopup;
